import { Component } from '@angular/core';
import { LoadingService } from './services/shared/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  isLoading!: boolean;
  constructor(public loadingService: LoadingService) {}
  title = 'paymewebportal.ui';

  ngOnInit() {
  }
}
